import { getCustomRegionTypes } from "forms/action-types"
import * as djangioActionCreators from "shared/djangio/action-creators"

export const getCustomRegions = () =>
    djangioActionCreators.resourceGetList(
        DjangIO.app.userdata.models.CustomRegionSelection,
        getCustomRegionTypes,
        { limit: 0 },
        {},
        true
    )
